import { request } from "../utilities/request";
import { getSanitizedString } from "../utilities/validation";

//TODO:: fix this url in config file
const URL = "https://biobigbox.com";

function doLogin(requestBody) {
    let formData = new FormData();
    formData.append("username", requestBody.username);
    formData.append("password", requestBody.password);
    formData.append("room_name", getSanitizedString(requestBody.room_name));


    return request(
        URL + "/index.php/blueskymeet/login",
        "POST",
        { "Content-Type": "multipart/form-data" },
        formData
    )
        .then((response) => {
            return response;
        })
        .catch((error) => {
            throw error;
        });
}

function doSSOLogin(requestBody) {
    let formData = new FormData();
    formData.append("sso_token", requestBody.sso_token);
    formData.append("room_name", getSanitizedString(requestBody.room_name));


    return request(
        "https://biobigbox.com/blueskymeet/sso_login",
        "POST",
        { "Content-Type": "multipart/form-data" },
        formData
    )
        .then((response) => {
            return response;
        })
        .catch((error) => {
            throw error;
        });
}

function getJwt(requestBody) {
    let formData = new FormData();
    formData.append("user_token", requestBody.user_token);
    formData.append("room_name", getSanitizedString(requestBody.room_name));

    return request(
        URL + "/index.php/blueskymeet/create",
        "POST",
        { "Content-Type": "multipart/form-data" },
        formData
    )
        .then((response) => {
            return response;
        })
        .catch((error) => {
            throw error;
        });

}

function forgotPassword(username) {
    let formData = new FormData();
    formData.append("username", username);
    return request(
        URL + "/blueskymeet/forgot_password",
        "POST",
        { "Content-Type": "application/x-www-form-urlencoded" },
        formData
    )
    .then((response) => {
        return response;
    })
    .catch((error) => {
        throw error;
    });
}

function resetPassword(requestBody){
    let formData=new FormData();
    formData.append("userid", requestBody.userid);
    formData.append("uuid", requestBody.uuid);
    formData.append("password", requestBody.password);
    formData.append("retypepwd", requestBody.retypepwd);
    return request(
        URL+"/blueskymeet/reset_password",
        "POST",
        { "Content-Type": "application/x-www-form-urlencoded" },
        formData
    )
    .then((response) => {
        return response;
    })
    .catch((error) => {
        throw error;
    });
}
const apiService = {
    doLogin,
    doSSOLogin,
    getJwt,
    forgotPassword,
    resetPassword
};

export default apiService;
